import { Component, input, computed, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CdkMenuModule } from "@angular/cdk/menu";
import { OverlayModule } from "@angular/cdk/overlay";
import { LucideAngularModule, Settings2, ChevronRight } from "lucide-angular";
import type { ToolsMenuItem } from "./ai-chat-input.types";
import { cn } from "../utils/utils";
import { injectChatLabels } from "../core/chat-labels";

@Component({
  selector: "agent-chat-tools-menu",
  standalone: true,
  imports: [CommonModule, CdkMenuModule, OverlayModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    @if (hasItems()) {
    <button type="button" [disabled]="disabled()" [class]="buttonClass()" [cdkMenuTriggerFor]="menu">
      <lucide-angular [img]="Settings2Icon" [size]="18"></lucide-angular>
      <span class="achat-tools-btn__label">{{ label }}</span>
    </button>

    <ng-template #menu>
      <div class="achat-menu" cdkMenu>
        @for (item of toolsMenu(); track $index) { @if (item === "-") {
        <div class="achat-menu__separator"></div>
        } @else if (isMenuItem(item)) { @if (item.items && item.items.length > 0) {
        <button type="button" class="achat-menu__item" [cdkMenuTriggerFor]="submenu" cdkMenuItem>
          {{ item.label }}
          <lucide-angular [img]="ChevronRightIcon" [size]="12" class="achat-menu__item-chevron"></lucide-angular>
        </button>

        <ng-template #submenu>
          <div class="achat-menu" cdkMenu>
            @for (subItem of item.items; track $index) { @if (subItem === "-") {
            <div class="achat-menu__separator"></div>
            } @else if (isMenuItem(subItem)) {
            <button type="button" class="achat-menu__item" (click)="handleItemClick(subItem)" cdkMenuItem>
              {{ subItem.label }}
            </button>
            } }
          </div>
        </ng-template>
        } @else {
        <button type="button" class="achat-menu__item" (click)="handleItemClick(item)" cdkMenuItem>
          {{ item.label }}
        </button>
        } } }
      </div>
    </ng-template>
    }
  `,
})
export class AgentChatToolsMenu {
  readonly Settings2Icon = Settings2;

  readonly ChevronRightIcon = ChevronRight;

  inputToolsMenu = input<(ToolsMenuItem | "-")[] | undefined>();

  inputDisabled = input<boolean | undefined>();

  inputClass = input<string | undefined>();

  private labels = injectChatLabels();

  toolsMenu = computed(() => this.inputToolsMenu() ?? []);

  disabled = computed(() => this.inputDisabled() ?? false);

  customClass = computed(() => this.inputClass());

  hasItems = computed(() => this.toolsMenu().length > 0);

  readonly label = this.labels.chatInputToolbarToolsButtonLabel;

  buttonClass = computed(() => cn("achat-tools-btn", this.customClass()));

  isMenuItem(item: any): item is ToolsMenuItem {
    return item && typeof item === "object" && "label" in item;
  }

  handleItemClick(item: ToolsMenuItem): void {
    if (item.action) {
      item.action();
    }
  }
}
